import {FC} from 'react'
import {TitleContainer} from 'components/layout/TitleContainer'
import {MainTitle} from 'components/ui/MainTitle'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Container, StartProcedureCard} from 'features/procedures/StartProcedureCard'

export const Presenter: FC = () => {
  return (
    <div>
      <TitleContainer subPage>
        <MainTitle>育休の手続きを選択</MainTitle>
      </TitleContainer>
      <Container>
        <StartProcedureCard to={WITH_AUTH_ADMIN_PATHS.START_CHILDCARE.INDEX} variant="start">
          育休の開始
        </StartProcedureCard>
        <StartProcedureCard to={WITH_AUTH_ADMIN_PATHS.EXTEND_CHILDCARE.INDEX} variant="start">
          育休の延長
        </StartProcedureCard>
        <StartProcedureCard to={WITH_AUTH_ADMIN_PATHS.FINISH_CHILDCARE.INDEX} variant="start">
          育休の終了
        </StartProcedureCard>
        <StartProcedureCard to={WITH_AUTH_ADMIN_PATHS.ADDITIONAL_CHILDCARE_LEAVE_ALLOWANCE.INDEX} variant="start">
          2回目以降の
          <br />
          育児休業給付申請
        </StartProcedureCard>
      </Container>
    </div>
  )
}
